/*
* Default Date and Time Formats used in the Custom Stamp Modal
* date and time will be joined with a space in between for the dropdown in the Modal
* If timeFirst is set to true, the time will be added infront of the date instead of at the end
*/
export default [
  {
    date: 'DD/MM/YYYY',
    time: 'h:mm A',
    timeFirst: false,
  },
  {
    date: 'DD/MM/YYYY',
    time: 'HH:mm',
    timeFirst: false,
  },
  {
    date: 'DD/MM/YYYY',
    time: 'h:mm A',
    timeFirst: false,
  },
  {
    date: 'DD/MM/YYYY',
    time: 'HH:mm',
    timeFirst: false,
  },
  {
    date: 'YYYY/MM/DD',
    time: 'h:mm A',
    timeFirst: false,
  },
  {
    date: 'YYYY/MM/DD',
    time: 'HH:mm',
    timeFirst: false,
  },
  {
    date: 'DD MMM YYYY',
    time: 'h:mm A',
    timeFirst: false,
  },
  {
    date: 'DD MMM YYYY',
    time: 'HH:mm',
    timeFirst: false,
  },
  {
    date: 'MMMM DD, YYYY',
    time: 'h:mm A',
    timeFirst: false,
  },
  {
    date: 'MMMM DD, YYYY',
    time: 'HH:mm',
    timeFirst: false,
  },
];